import { useDeleteEntityApi } from '@/common/api/deleteEntityApi';
import { useMappingProfileStore } from 'shared/products/mapping/stores/mappingProfileStore';

export interface DeleteMappingProfileResponse {
  ok: true;
}

export function useDeleteMappingProfile() {
  const store = useMappingProfileStore();

  return useDeleteEntityApi({
    url: 'mappingProfile',
    translate: (t) => t.products.actions.delete,
    async processOk(request) {
      store.remove(request.id);

      return {
        ok: true,
      };
    },
  });
}
